declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dataLayer: any[];
  }
}

/** GTM pushes are independent of the Mixpanel flag and of initAnalytics(). */
export function pushDataLayer(
  event: string,
  extra?: Record<string, unknown>,
): void {
  if (typeof window === "undefined") return;
  window.dataLayer ??= [];
  window.dataLayer.push({ event, ...extra });
}
